import React, { useEffect, useState } from "react";
import RecipeCard from "./RecipeCard";

export default function RecipeBuilder({
  recipes,
  setRecipes,
  shoppingList,
  setShoppingList,
  loadIngredientCache,
  saveIngredientCache,
  updateRecipeInAirtable,
  deleteRecipe,
  setReplaceModal,
  newTitle,
  setNewTitle,
  newIngredients,
  setNewIngredients,
  addRecipe,
  recipesInShoppingList,
  setRecipesInShoppingList
}) {
  // --- Move levenshtein and refreshSequentially outside the render/loop ---




  // Show 'Recipe added' message
  const [showAddedMsg, setShowAddedMsg] = useState(false);

  // Quantity update handler for IngredientRow
  useEffect(() => {
    window.updateIngredientQuantity = (recipeIdx, ingredientIdx, qty) => {
      setRecipes(prev => prev.map((rec, ridx) => {
        if (ridx !== recipeIdx) return rec;
        const newIngredients = rec.ingredients.map((ing, i) => i === ingredientIdx ? { ...ing, quantity: qty } : ing);
        const updated = { ...rec, ingredients: newIngredients };
        updateRecipeInAirtable(updated);
        return updated;
      }));
    };
    return () => { window.updateIngredientQuantity = undefined; };
  }, [setRecipes, updateRecipeInAirtable]);


  return (
    <div>
      {/* Recipe cards */}
      <div className="grid gap-4 mb-6">
        {recipes.map((r, recipeIdx) => {
          // Each ingredient is now always an object
          const ingredientDetails = r.ingredients.map((ing) => {
            if (typeof ing === 'string') {
              // fallback for legacy data
              return { title: ing, image: '', price: '£0.00', available: true };
            }
            // If shoppingList has a more up-to-date image/price, use it
            const found = shoppingList.find((item) => {
              // Match by productId if present, else by link, else by title
              if (ing.productId && item.productId) {
                return ing.productId === item.productId;
              }
              if (ing.link && item.link) {
                return ing.link === item.link;
              }
              return item.title === ing.title;
            });
            return found ? { ...ing, image: found.image, price: found.price, available: ing.available !== false } : { ...ing, available: ing.available !== false };
          });
          const total = ingredientDetails.reduce((sum, item) => sum + (parseFloat(item.price?.replace('£','')) || 0), 0);
          const isNew = showAddedMsg && recipesInShoppingList.includes(r.id);
          return (
            <RecipeCard
              key={r.id}
              recipe={r}
              recipeIdx={recipeIdx}
              ingredientDetails={ingredientDetails}
              total={total}
              isNew={isNew}
              onRefresh={async () => {}}
              refreshing={r._refreshing}
              refreshProgress={r._refreshProgress}
              lastUpdated={r._lastUpdated}
              onDelete={() => deleteRecipe(r.id)}
              onAddToShoppingList={() => {
                setShoppingList((prev) => {
                  let updated = [...prev];
                  r.ingredients.forEach((ingredient) => {
                    const qty = ingredient.quantity || 1;
                    const idx = updated.findIndex((item) => item.title === ingredient.title);
                    if (idx !== -1) {
                      updated[idx] = { ...updated[idx], quantity: (updated[idx].quantity || 1) + qty };
                    } else {
                      updated.push({ title: ingredient.title, image: ingredient.image, price: ingredient.price, quantity: qty });
                    }
                  });
                  return updated;
                });
                setRecipesInShoppingList(prev => prev.includes(r.id) ? prev : [...prev, r.id]);
                setShowAddedMsg(true);
                setTimeout(() => setShowAddedMsg(false), 1200);
              }}
              setReplaceModal={setReplaceModal}
              setRecipes={setRecipes}
              updateRecipeInAirtable={updateRecipeInAirtable}
            />
          );
        })}
      </div>

      {showAddedMsg && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-6 py-2 rounded shadow-lg z-50 transition-all">Recipe added</div>
      )}

      {/* Add new recipe */}
      <div className="p-4 border-t">
        <h2 className="text-lg font-semibold mb-2">Add New Recipe</h2>
        <input
          type="text"
          placeholder="Recipe Title"
          className="border p-2 w-full mb-2"
          value={newTitle}
          onChange={(e) => setNewTitle(e.target.value)}
        />
        <input
          type="text"
          placeholder="Ingredients (comma separated)"
          className="border p-2 w-full mb-2"
          value={newIngredients}
          onChange={(e) => setNewIngredients(e.target.value)}
        />
        <button
          onClick={addRecipe}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          disabled={!newTitle || !newIngredients}
        >
          Save Recipe
        </button>
      </div>
    </div>
  );
}
